import InsuranceModuleSliceType from './InsuranceModuleSliceType';

const InsuranceModuleInitialState: InsuranceModuleSliceType = {
  loading: false,
  data: [],
};

export default InsuranceModuleInitialState;
